<template>
  <div>
    <el-card class="page-container">
      <el-row class="title-biaoti">游戏幸运奖事件管理</el-row>
      <el-row class="search">
        <el-date-picker
          v-model="queryInfo.date"
          type="datetimerange"
          value-format="yyyy-MM-dd hh:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
        <el-select
          v-model="queryInfo.channel"
          placeholder="渠道"
          style="width: 200px"
          clearable
        >
          <el-option
            v-for="item in channels"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-select
          clearable
          v-model="queryInfo.valid"
          placeholder="是否有效"
          style="width: 200px"
        >
          <el-option label="有效" value="1" />
          <el-option label="无效" value="0" />
        </el-select>
        <el-input
          clearable
          v-model="queryInfo.username"
          placeholder="操作人"
          style="width: 200px"
        ></el-input>

        <el-button type="primary" @click="query(true)" :loading="login">查询 </el-button>
        <el-button type="warning" @click="operate(1)">新增 </el-button>
      </el-row>
      <el-row>
        <el-table :data="datalist" style="width: 100%" v-loading="login" stripe border>
          <el-table-column prop="eventCode" label="事件码" width="80px" />
          <el-table-column prop="channel" label="渠道" />
          <el-table-column prop="awardType" label="奖励类型" width="80px">
            <el-tag type="success">金币</el-tag>
          </el-table-column>
          <el-table-column prop="valid" label="是否有效" width="80px">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.valid == 1" type="success">有效</el-tag>
              <el-tag v-else type="danger">无效</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="gameIdSet" label="游戏" min-width="100px" align="left">
            <template slot-scope="scope">
              <!-- vfor循环便利gameIdSet，匹配对应的label显示 -->
              <div class="flex-gap-box">
                <span v-for="item in gameIdType" :key="item.value">
                  <el-tag v-if="scope.row.gameIdSet.includes(item.value)" type="success">
                    {{ item.label }}
                  </el-tag>
                </span>
              </div>
            </template>
          </el-table-column>
          <!-- rewardConfig -->
          <el-table-column
            prop="rewardConfig"
            label="奖励配置"
            align="left"
            min-width="140px"
          >
            <template slot-scope="scope">
              <div class="flex-gap-box">
                <span
                  v-for="(item, idx) in scope.row.rewardConfig.rewardConfigs"
                  :key="item.criteria"
                >
                  <p>条件：{{ item.criteria }} 数量：{{ item.rewardNum }}</p>
                  <!-- <el-tag type="success">
                    条件：{{ item.criteria }} 数量：{{ item.rewardNum }}
                  </el-tag> -->
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="awardMaxLimit" label="限制奖品最大数量" width="80px" />
          <el-table-column prop="awardNum" label="奖品发放数量" width="80px" />
          <el-table-column
            prop="everyOneReceiveTimeLimit"
            label="领取次数限制"
            width="80px"
          />
          <el-table-column prop="startTime" label="开始时间" width="94px" />
          <el-table-column prop="endTime" label="结束时间" width="94px" />
          <el-table-column prop="operator" label="操作人" />
          <el-table-column fixed="right" label="操作" width="100">
            <template #default="{ row }">
              <div class="flex-gap-box">
                <el-button type="primary" size="small" @click="operate(2, row)">
                  编辑
                </el-button>

                <el-button
                  style="margin-left: 0"
                  type="primary"
                  size="small"
                  v-if="row.valid == 0"
                  @click="handleValid(1, row.id)"
                  >启用
                </el-button>
                <el-button
                  style="margin-left: 0"
                  type="danger"
                  size="small"
                  v-else
                  @click="handleValid(0, row.id)"
                  >禁用
                </el-button>
                <el-button
                  type="primary"
                  size="small"
                  @click="handleDetails(row.eventCode)"
                >
                  数据导出
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="pageInfo.page"
          :page-size="pageInfo.pageSize"
          layout="total, prev, pager, next"
          :total="pageInfo.total"
        >
        </el-pagination>
      </el-row>

      <el-dialog
        :title="isAdd ? '新增' : '修改'"
        :visible.sync="dialog"
        width="40%"
        :before-close="handleClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form :model="data" label-width="160px" ref="form">
          <el-form-item label="渠道">
            <el-select v-model="data.channel" placeholder="请选择渠道">
              <el-option
                v-for="item in channels_no_all"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="游戏">
            <el-select v-model="data.gameIdSet" multiple placeholder="请选择游戏">
              <el-option
                v-for="item in gameIdType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="开始时间">
            <el-date-picker
              v-model="data.startTime"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd hh:mm:ss"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间">
            <el-date-picker
              v-model="data.endTime"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd hh:mm:ss"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="奖励类型">
            <el-radio-group v-model="data.awardType">
              <el-radio label="1">金币</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否有效">
            <el-radio-group v-model="data.valid">
              <el-radio label="1">有效</el-radio>
              <el-radio label="0">无效</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="限制奖品最大数量">
            <el-input v-model="data.awardMaxLimit" placeholder="请输入限制奖品最大数量" />
          </el-form-item>
          <el-form-item label="活动期间领取次数限制">
            <el-input
              v-model="data.everyOneReceiveTimeLimit"
              placeholder="请输入活动期间领取次数限制"
            />
          </el-form-item>
          <el-form-item label="奖励配置">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="条件" label-width="80px">
                  <el-input
                    type="number"
                    v-model="item.criteria"
                    placeholder="输入奖励条件"
                  />
                </el-form-item>
                <el-form-item label="数量" label-width="80px">
                  <el-input
                    type="number"
                    v-model="item.rewardNum"
                    placeholder="输入奖励数量"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-button type="danger" @click="addRewardConfig()"> 增加 </el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <!-- 遍历显示 rewardConfig.rewardConfigs -->
          <el-form-item
            v-for="(item, index) in data.rewardConfig.rewardConfigs"
            :key="index"
          >
            <el-row class="item">
              <span>条件: {{ item.criteria }}</span>
              <span>数量: {{ item.rewardNum }}</span>
              <el-button type="danger" @click="deleteRewardConfig(index)">
                删除
              </el-button>
            </el-row>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="submit" type="primary" :loading="dwnload">
            {{ isAdd ? "新增" : "修改" }}
          </el-button>
          <el-button @click="handleClose">取 消</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import download from "@/utils/download.js";

export default {
  data() {
    return {
      activeIndex: 0,
      login: false,
      dwnload: false,
      datalist: [],
      dialog: false,
      data: {
        channel: "",
        startTime: "",
        endTime: "",
        awardType: "1",
        awardMaxLimit: "",
        everyOneReceiveTimeLimit: "",
        valid: "1",
        gameIdSet: [],
        rewardConfig: {
          rewardConfigs: [],
        },
        dataId: 0,
        operator: this.$store.getters.username,
      },
      item: {
        criteria: "",
        rewardNum: "",
      },
      gameIdType: [
        {
          label: "joy:car race",
          value: "2:201:101",
        },
        {
          label: "yxsk:Teen Patti",
          value: "2:111:102",
        },
        {
          label: "yxsk:Greedy cat",
          value: "2:112:103",
        },
        {
          label: "yxsk:Guessing fists",
          value: "2:113:104",
        },
        {
          label: "yxsk:Ludo",
          value: "2:114:105",
        },
        {
          label: "yxsk:Turntable",
          value: "2:115:106",
        },
        {
          label: "joy:slot",
          value: "2:202:107",
        },
        {
          label: "joy:fruit machine",
          value: "2:203:108",
        },
        {
          label: "joy:blackjack",
          value: "2:204:109",
        },
        {
          label: "baishun:greedy",
          value: "4:1006:111",
        },
        {
          label: "baishun:fishing star",
          value: "4:1022:112",
        },
        {
          label: "baishun:crash",
          value: "4:1031:115",
        },
        {
          label: "self:greedy",
          value: "7:10001:116",
        },
        {
          label: "self:battle",
          value: "7:10003:117",
        },
        {
          label: "self:teenpatti",
          value: "7:10008:119",
        },
        {
          label: "self:yummy_slot",
          value: "7:10008:120",
        },
        {
          label: "self:animal_party",
          value: "7:10002:121",
        },
        {
          label: "self:royal_battle",
          value: "7:10011:122",
        },
      ],
      pageInfo: {
        page: 1,
        total: 0,
        pageSize: 10,
      },
      queryInfo: {
        startDate: "",
        endDate: "",
        date: "",
        channel: "",
        valid: "1",
        username: "",
      },
      isAdd: true,
      channels: this.$store.state.channels,
      channels_no_all: [],
    };
  },
  created() {
    this.query();
  },
  methods: {
    addRewardConfig() {
      this.data.rewardConfig.rewardConfigs.push({
        criteria: this.item.criteria,
        rewardNum: this.item.rewardNum,
      });
      this.item.criteria = "";
      this.item.rewardNum = "";
    },
    deleteRewardConfig(index) {
      this.data.rewardConfig.rewardConfigs.splice(index, 1);
    },
    async query(page) {
      if (page) this.pageInfo.page = 1;
      this.login = true;
      const params = {
        username: this.$store.getters.username,
        token: this.$store.getters.token,
        page: this.pageInfo.page,
      };
      if (this.queryInfo.date) {
        params.startDate = this.queryInfo.date[0];
        params.endDate = this.queryInfo.date[1];
      }
      if (this.queryInfo.channel) params.channel = this.queryInfo.channel;
      if (this.queryInfo.valid) params.valid = this.queryInfo.valid;
      if (this.queryInfo.username) params.operator = this.queryInfo.username;

      const { data: res } = await this.$axios({
        type: "GET",
        url: this.$store.getters.path.popup_list,
        withCredentials: true,
        params,
      });
      this.login = false;
      if (res.code != 0) return this.$message(res.msg);
      this.datalist = res.data.data;
      this.pageInfo.total = res.data.total;
    },

    async operate(type, row) {
      this.isAdd = type === 1;
      this.dialog = true;
      if (this.isAdd) return;
      row.valid = row.valid + "";
      row.awardType = row.awardType + "";
      this.data = {
        ...row,
      };
      console.log(this.data);
    },
    submit() {
      if (this.isAdd) {
        this.add();
      } else {
        this.edit();
      }
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.query();
    },
    async add() {
      this.dwnload = true;
      const { data: res } = await this.$axios({
        method: "post",
        url: this.$store.getters.path.popup_add,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data: {
          ...this.data,
        },
      });
      this.dwnload = false;
      if (res.code !== 0) return this.$message.error(res.msg);
      this.$message.success("新增成功");
      this.query(true);
      this.handleClose();
    },
    async edit() {
      this.dwnload = true;
      const { data: res } = await this.$axios({
        method: "post",
        url: this.$store.getters.path.popup_update,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data: {
          ...this.data,
        },
      });
      this.dwnload = false;
      if (res.code !== 0) return this.$message.error(res.msg);
      this.$message.success("修改成功");
      this.query();
      this.handleClose();
    },
    handleClose() {
      this.dialog = false;
      // 清空表单
      this.data = {
        channel: "",
        startTime: "",
        endTime: "",
        awardType: "1",
        awardMaxLimit: "",
        everyOneReceiveTimeLimit: "",
        valid: "1",
        gameIdSet: [],
        rewardConfig: {
          rewardConfigs: [],
        },
        dataId: 0,
        operator: this.$store.getters.username,
      };
      this.item = {
        criteria: "",
        rewardNum: "",
      };
    },
    // 修改状态
    async handleValid(status, rowId) {
      //弹窗提示二次确定
      this.$confirm("是否确认操作?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.dwnload = true;
          const { data: res } = await this.$axios({
            url: this.$store.getters.path.popup_update_status,
            withCredentials: true,
            params: {
              username: this.$store.getters.username,
              token: this.$store.getters.token,
              valid: status,
              id: rowId,
            },
          });
          this.dwnload = false;
          if (res.code !== 0) return this.$message.error(res.msg);
          this.$message.success("操作成功");
          this.query();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    async handleDetails(eventCode) {
      const { data: res } = await this.$axios({
        url: this.$store.getters.path.popup_user_reward,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          eventCode,
        },
        responseType: "blob",
      });
      download(res, "游戏幸运奖用户领奖数据" + eventCode);
    },
  },
  mounted() {
    this.channels_no_all = this.channels.filter((item) => item.value !== "all");
  },
};
</script>

<style lang="scss" scoped>
.search {
  display: flex;
  align-items: center;

  > * {
    margin: 0 3px;
  }
}

.item {
  display: flex;
  align-items: center;
  padding: 5px 0;

  span {
    white-space: nowrap;
    padding: 0 5px;
  }
}
.flex-gap-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
}
</style>
